/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-15 12:46:51
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-05-27 16:42:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/index.tsx
 */
import { NoDataPage } from '@/src/components';
import { Breadcrumb, Button, Upload } from '@/src/components/Antd';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Spin } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { FileList } from './Components';
import { breadcrumbData } from './config';
import useService from './service';
import styles from './style.module.less';
function FileLibrary() {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const canUpload = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsFileLibrary,
        operation: EnumOperation.upload_and_edit_file,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsFileLibrary,
        operation: EnumOperation.delete_file,
      }),
    ],
  });

  const canViewDetail = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsFileLibrary,
        operation: EnumOperation.view_file_details,
      }),
    ],
  });
  const canViewList = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsFileLibrary,
        operation: EnumOperation.view_file_library_listing_page,
      }),
    ],
  });

  const {
    fileList,
    hasBeenConfiged,
    total,
    tags,
    loading,
    handleSearchFiles,
    handleChangeFileList,
    handleDeleteFiles,
    featchData,
  } = useService(canViewList);

  const history = useHistory();

  const handleNavigate = (uuid: string) => {
    if (canViewDetail && uuid) {
      history.push(`/settings/fileLibrary/${uuid}`);
    }
  };

  const renderButton = () => (
    <div className={styles.upload}>
      <Upload accept='image/*,video/*' onChange={featchData}>
        <Button type='primary' className={styles.button} disabled={!canUpload}>
          {getI18n('general.antd.Uploader.upload_files')}
        </Button>
      </Upload>
    </div>
  );
  return (
    <div className={styles.container}>
      <div className={styles.breadcrumb}>
        <Breadcrumb
          className={styles.breadcrumb}
          breadcrumbData={breadcrumbData({ getI18n })}
        />
      </div>
      <div className={styles.content}>
        <Spin spinning={loading}>
          {!hasBeenConfiged ? (
            <NoDataPage
              title={getI18n(
                'storeFileLibrary.detail.uploadfilestofilelibrary',
              )}
              introduce={`${getI18n(
                'storeFileLibrary.detail.supportedfileformat',
              )}: .apng, .jpg, .jpeg, .gif, .png, .svg, .pdf, .mov, .mp4`}
              renderButton={renderButton}
            />
          ) : (
            <FileList
              canUpload={canUpload}
              canDelete={canDelete}
              tagList={tags.map((t) => ({ key: t.uuid, name: t.name }))}
              total={total}
              files={fileList}
              onSearch={handleSearchFiles}
              onDelete={handleDeleteFiles}
              onChangeFileList={handleChangeFileList}
              onNavigateToFileDetail={handleNavigate}
            />
          )}
        </Spin>
      </div>
    </div>
  );
}

export default FileLibrary;
